import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipesModule} from './pipes/pipes.module';
import {PartialsModule} from './partials/partials.module';
import {RouterModule} from '@angular/router';
import {DialogsModule} from './dialogs/dialogs.module';
import { MatDialogModule } from '@angular/material/dialog';
import {PagesModule} from './pages/pages.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {CdkTableModule} from '@angular/cdk/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatSortModule} from '@angular/material/sort';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {RootsModule} from './roots/roots.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GalleryModule } from 'ng-gallery';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {BriefdFormModule} from './briefd-form/briefd-form.module';
import {NgChartsModule} from 'ng2-charts';
import {DirectivesModule} from './directives/directives.module';
import {AdvertisingLogoComponent} from '@app/partials/advertising-logo/advertising-logo.component';
import {ComponentsModule} from './components/components.module';

@NgModule({ declarations: [
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        GalleryModule,
        MatDialogModule,
        CdkTableModule,
        MatAutocompleteModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatDatepickerModule,
        DragDropModule,
        MatTooltipModule,
        NgxDropzoneModule,
        MatSnackBarModule,
        ClipboardModule,
        PipesModule,
        PartialsModule,
        DialogsModule,
        PagesModule,
        RootsModule,
        BriefdFormModule,
        ComponentsModule
    ], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MatDialogModule,
        CdkTableModule,
        MatAutocompleteModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSortModule,
        MatDatepickerModule,
        DragDropModule,
        MatTooltipModule,
        NgxDropzoneModule,
        MatSnackBarModule,
        ClipboardModule,
        GalleryModule,
        PipesModule,
        PartialsModule,
        DialogsModule,
        PagesModule,
        RootsModule,
        BriefdFormModule,
        NgChartsModule,
        DirectivesModule,
        ComponentsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class SharedModule {
}
